import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import PLIMenuLogo from '../../../assets/PLI_HamburgerMenu.svg';

const useStyles = makeStyles(() => ({
  button: {
    background: 'transparent',
    border: 'none',
    padding: 12
  }
}));

export interface LogoButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const LogoButton = ({ onClick }: LogoButtonProps): React.ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation('LogoButton');

  return (
    <button
      aria-label={t('Toggle Navigation Drawer')}
      tabIndex={0}
      className={clsx(classes.button)}
      onClick={onClick}
    >
      <img src={PLIMenuLogo} alt="Live Insights - The Dashboard for Digital Teaching" />
    </button>
  );
};

export default LogoButton;
